<template>
  <div class="affiliate-select-box">

  <v-select
      v-bind:multiple="multi || selectProps.multiple"
      :clearable="clearable"
      v-model="model"
      :options="userOptions"
      label="fullName"
      :reduce="user => user.id"
      v-bind="selectProps"
      class="full-width-select"
      :close-on-select="!(multi || selectProps.multiple)"
      :deselectFromDropdown="true"
  >

  <template #list-header>
    <div
        v-if="multiple || selectProps.multiple"
        class="dropdown-actions d-flex justify-content-between align-items-center px-2 py-1"
    >
      <b-button size="sm" variant="outline-success" class="action-btn" @mousedown.stop.prevent="selectAll">
        Select All
      </b-button>
      <b-button size="sm" variant="outline-danger" class="action-btn" @mousedown.stop.prevent="unselectAll">
        Unselect All
      </b-button>
      <hr class="m-1" />
    </div>
  </template>
    <template #option="option">
      <div class="d-flex align-content-center align-items-center">
        <b-avatar
            size="20"
            variant="light-primary"
            :src="require(`@/assets/images/avatars/${option.avatar || '1'}-small.png`)"
            class="mr-1"
        />
        <div class="">

          <p class="m-0 font-small-2 p-0">{{ option.fullName }}</p>
          <p class="m-0 font-small-1 text-muted p-0" v-if="showRoles">{{roleById(option.roleId).name }}</p>
        </div>
      </div>

    </template>
  </v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserSelectBox',
  props: {
    value: {
      required: true,
    },
    nullable: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
    showRoles: {
      type: Boolean,
      default: false
    },
    roles:{
      type: Array,
      default: () => []
    }
  },
  created() {
    if((this.showRoles || this.roles?.length > 0) && this.allRoles.length === 0) {
      this.refreshData();
    }
  },
  computed: {
    ...mapGetters('users', ['allRoles','roleById']),

    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    userOptions() {
      let users = this.$store.getters['data/allUsers'] || [];

      if(this.roles.length > 0) {
        users = users.filter(user => this.roles.includes(this.roleById(user.roleId).companyPosition));
      }
      console.log('nullable', this.selectProps.nullable);
      if (this.selectProps.nullable) {
        return [
          { id: null, username: 'NOT ASSIGNED', fullName: 'NOT ASSIGNED' },
          ...users
        ];
      }

      return users;
    }
  },

  methods: {
    ...mapActions('users', ['refreshData']),

    selectAll() {
      const allIds = this.userOptions
          .filter((opt) => opt.id !== null)
          .map((opt) => opt.id);
      this.$nextTick(() => this.$emit('input', allIds));
    },
    unselectAll() {
      this.$nextTick(() => this.$emit('input', []));
    },
  },


};
</script>

<style scoped>
.dropdown-actions {
  position: sticky;
  top: 0;
  z-index: 5; /* higher than options */
  background-color: #fff; /* ensures options don't bleed through */
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
}

/* dark theme fix */
.dark-layout .dropdown-actions {
  background-color: rgb(30, 31, 36);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.action-btn {
  min-width: 90px;
  font-size: 0.75rem;
}

</style>
